import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { PhotoSwipeGallery } from 'react-photoswipe'
let options = {
    //http://photoswipe.com/documentation/options.html
}
  
let getThumbnailContent = item => {
    return (
        <div
            className="gallery-item"
            itemProp="associatedMedia"
            itemScope=""
            itemType="http://schema.org/ImageObject"
        >
            <a data-size="750x1002" href={item.src} itemProp="contentUrl">
            <img
                alt="..."
                className="img-rounded img-responsive"
                itemProp="thumbnail"
                src={item.src}
            />
            </a>
            <figcaption className="gallery-caption" itemProp="caption description">
            {item.title}
            </figcaption>
      </div>
    )
}
const photoSwipeItems = [
    {
      src: require("assets/images/galeria/1.jpg"),
      title: "",
      w: "1024",
      h: "682"
    },
    {
        src: require("assets/images/galeria/5.jpg"),
        title: "",
        w: "1024",
        h: "682"
    },
    {
      src: require("assets/images/galeria/15.jpg"),
      title: "",
      w: "1024",
      h: "682"
    },
    {
        src: require("assets/images/galeria/17.jpg"),
        title: "",
        w: "1024",
        h: "682"
    },
    {
        src: require("assets/images/galeria/18.jpg"),
        title: "",
        w: "1024",
        h: "682"
    },
    {
        src: require("assets/images/galeria/28.jpg"),
        title: "",
        w: "1000",
        h: "682"
    },
    {
        src: require("assets/images/galeria/ext08.jpg"),
        title: "",
        w: "1024",
        h: "576"
    },
    {
        src: require("assets/images/galeria/ext14.jpg"),
        title: "",
        w: "1024",
        h: "576"
    },
    {
        src: require("assets/images/galeria/ext15.jpg"),
        title: "",
        w: "1024",
        h: "576"
    },
    {
        src: require("assets/images/galeria/ext17.jpg"),
        title: "",
        w: "1000",
        h: "576"
    },
    {
        src: require("assets/images/galeria/ext18.jpg"),
        title: "",
        w: "1000",
        h: "576"
    },
  ];
const Galeria = () => {
    return(
        <div className="section text-center" id="galeria">
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto text-center" md="8">
                        <h2 className="title">Galería</h2>
                    </Col>
                </Row>
                
                    <PhotoSwipeGallery
                        items={photoSwipeItems}
                        options={options}
                        thumbnailContent={getThumbnailContent}
                    />
                
            </Container>
        </div>
    )
}
export default Galeria